'use client';
import { memo, useEffect, useState } from 'react';
import { richTextFromMarkdown } from '@contentful/rich-text-from-markdown';
import { RichText } from '../RichText';
import { Document } from '@contentful/rich-text-types';

export interface MarkdownProps {
  content: string;
}

const Markdown = ({ content }: MarkdownProps) => {
  const [parsedContent, setParsedContent] = useState<Document>();

  useEffect(() => {
    const parse = async () => {
      const parsedContent = await richTextFromMarkdown(content);
      setParsedContent(parsedContent);
    };

    parse();
  }, [content]);

  return parsedContent ? <RichText content={parsedContent} /> : null;
};

export default memo(Markdown);
